'use client'
import React, { useEffect, useState } from 'react'
import { Select, SelectItem } from '@nextui-org/react'
import { Product } from '@/types'
import Link from 'next/link'
import Image from 'next/image'
import { cleanUrl } from '@/helpers/Functions/TopLevel'
import { useRouter } from 'next/navigation'
import { getProducts } from '@/helpers/ApiCalls/Base/GetProducts'
const colors = [
    { uid: "masala-unsweetened", bg: "bg-[#3B5A76]" },
    { uid: "elaichi-unsweetened", bg: "bg-[#67764F]" },
    { uid: "adrak-unsweetened", bg: "bg-[#977352]" },
    { uid: "kadak-unsweetened", bg: "bg-[#99403F]" },
    { uid: "kesar-unsweetened", bg: "bg-[#7E3965]" },
    { uid: "turmeric-unsweetened", bg: "bg-[#E17648]" },
]
const SelectProduct = ({ product, is1kg }: { product: Product, is1kg: boolean }) => {
    const router = useRouter()
    const [products, setProducts] = useState<Product[]>([]);
    const [sortedProducts, setSortedProducts] = useState<Product[]>([]);

    useEffect(() => {
        getProducts().then((data: Product[]) => {
            setProducts(data);
        }
        );
    }
        , []);

    useEffect(() => {
        const filtered = products.filter((fproduct: Product) =>
            fproduct.category === "Premix" && (fproduct.outofstock === 0 || fproduct.outofstock1kg === 0) && fproduct.isactive === 1 && fproduct.id !== product.id && (is1kg ? fproduct.price1kg > 0 : fproduct.price > 0)
        );
        filtered.unshift(product);
        setSortedProducts(filtered);
    }, [is1kg, product, products]);

    const handleChange = (e: any) => {
        const uid = products.find((item: Product) => item.id == e.target.value)?.uniqueid;
        if (uid) {
            router.push(`/products/${uid}`);
        }
    };

    if (!products.length || !sortedProducts.length) {
        return <div>Loading...</div>;
    }


    return (
        <Select placeholder='Select a product' onChange={handleChange}
            label={
                'Choose different product'
            }
            defaultSelectedKeys={[`${product.id}`]}
            disabledKeys={[`${product.id}`]}
            variant='faded'
            classNames={{
                trigger: `${colors.find((item) => item.uid === product.uniqueid)?.bg || "bg-amber-400"}  font-semibold focus:outline-none focus:border-none outline-none border-none shadow-lg hover:${colors.find((item) => item.uid === product.uniqueid)?.bg || "bg-amber-400"}  focus:ring-0`,
                base: `${colors.find((item) => item.uid === product.uniqueid) != undefined ? "!text-white" : "!text-black"}`,
                label: `${colors.find((item) => item.uid === product.uniqueid) != undefined ? "!text-white" : "!text-black"}`,
                value: `${colors.find((item) => item.uid === product.uniqueid) != undefined ? "!text-white" : "!text-black"}`
            }}

            labelPlacement='inside'
        >
            {
                sortedProducts
                    .map((item: Product) => {
                        let images = cleanUrl(item.imageurl);
                        return (
                            <SelectItem
                                key={item.id}
                                value={item.uniqueid}
                                startContent={<Image src={images[0]} width={128} height={128} alt={item.name} className='rounded-lg w-16 h-16 object-cover object-center' />}
                                endContent={<p className='text-black font-semibold text-medium'
                                >$
                                    {is1kg ? item.price1kg : item.price}
                                </p>}
                                textValue={`${item.englishname} (${item.type})`}

                            >
                                {item.englishname} ({item.type}) <br />
                                {item.name}
                            </SelectItem>
                        )
                    }
                    )

            }
        </Select>
    )
}

export default SelectProduct